<template>
  <div class="searchbar" :class="isAdvanced ? 'is-advanced column' : ''">
    <div class="columns mr-0">
      <div class="column is-narrow" v-if="isAdvanced">
        <mf-multi-select :modelValue="searchBy" track-by="value" label="label" :multiple="false"
          :options="searchOptions" :allow-empty="false" :closeOnSelect="true"
          @update:modelValue="($event) => setSearchBy($event)">
        </mf-multi-select>
      </div>
      <div class="is-divider-vertical" v-if="isAdvanced"></div>
      <div class="column pr-0">
        <div class="field">
          <p class="control has-icons-right">
            <input
              class="input"
              type="text"
              :placeholder="placeholder"
              v-model="searchText"
              :disabled="disableSearch"
              name="searchText"
              @keypress.enter="handleKeyPress"
            />
            <span class="icon is-small is-right" v-if="searchText.length > 0" @click="clearSearch">
              <i class="icon-close is-clickable"></i>
            </span>
          </p>
        </div>
      </div>
      <div class="column is-narrow" :class="isAdvanced ? 'h-20' : ''">
        <button class="button has-background-black-bis has-text-white p-0" @click="searchedValue(searchText)">
          <i class="icon-search"></i>
        </button>
      </div>
      <div class="is-divider-vertical" v-if="isAdvanced"></div>
      <div class="column is-narrow" v-if="isAdvanced">
        <button class="button has-background-black-bis has-text-white p-0" @click="isSearchGuideModalActive = !isSearchGuideModalActive">
          <span class="is-size-3 has-text-dark">i</span>
        </button>
      </div>
    </div>
  </div>
  <div>
    <SearchGuideModal
      :isActive="isSearchGuideModalActive"
      @close="isSearchGuideModalActive = !isSearchGuideModalActive"
    />
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, onUnmounted, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import SearchGuideModal from '@/components/modals/SearchGuide';
import { get, isEmpty } from 'lodash';

export default defineComponent({
  name: 'searchBar',
  components: {
    SearchGuideModal
  },
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    shouldEmit: {
      type: Boolean,
      default: false,
    },
    disableSearch: {
      type: Boolean,
      default: false,
    },
    searchValue: {
      type: String,
    },
    isAdvanced: {
      type: Boolean,
      default: false
    },
  },
  setup(props, { emit }) {
    const store = useStore();

    const state = reactive({
      searchText: props.searchValue || '',
      searchOptions: [
        { label: 'Order Name', value: 'name' },
        { label: 'All Fields', value: 'allFields' },
      ],
      searchBy: {},
      isSearchGuideModalActive: false
    });

    const clearSearch = () => {
      state.searchText = ''; // Reset searchText to clear the search field
      searchedValue(''); // Optionally, emit an empty string or perform any other necessary action
    };

    const setQueryParams = (key, val) => {
      const qryObj = { [key]: val };
      store.commit('setQueryParams', qryObj);
    };

    const searchedValue = (searchQuery) => {
      if (props.shouldEmit) {
        // emit the search back
        emit('search', searchQuery);
      } else {
        // set searchText in store
        setQueryParams('searchText', searchQuery);
      }
    };

    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        searchedValue(state.searchText);
        event.target.blur();
      }
    };

    onBeforeMount(() => {
      if (props.isAdvanced) {
        state.searchBy = get(store.state, 'queryParams.searchBy', { label: 'Order Name', value: 'name' })
      }
    })

    onUnmounted(() => {
      if (!props.shouldEmit) {
        setQueryParams('searchText', '');
      }
    });

    const setSearchBy = (val) => {
      state.searchBy = val
      setQueryParams('searchBy', state.searchBy);
    }

    return {
      ...toRefs(state),
      searchedValue,
      clearSearch,
      handleKeyPress,
      setSearchBy
    };
  },
});
</script>

<style lang="scss" scoped>
.is-advanced {
  background-color: #fff;
  padding-right: 6px !important;
  border-radius: 2px;
  max-width: unset !important;
  .column {
    padding: 0 !important
  }
  input:hover,
  input:active,
  input:focus,
  ::v-deep(.multiselect--active:not(.multiselect--above) .multiselect__tags),
  ::v-deep(.multiselect__tags:hover) {
    border-color: transparent !important;
  }
  ::v-deep(.multiselect__tags) {
    border-radius: 2px !important;
  }
  .is-divider-vertical {
    min-height: 16px;
    max-height: 16px;
    padding-block: 1px !important;
    margin: 4px 8px!important;
  }
  .control.has-icons-right .input {
    padding-right: 24px !important
  }
  button {
    height: 20px !important;
    width: 20px !important;
    border: 1px solid #999 !important;
    background-color: #e2e5e7 !important;
    margin-top: 2px;
    color: #000;
    i, i::before {
      font-size: 16px !important;
      color: #000;
    }
    &:hover span, &:hover i::before {
      color: #fff !important;
    }
    &:hover {
      border-color: #fe8137 !important;
    }
  }
  ::v-deep(.multiselect) {
    width: 135px !important
  }
}
::v-deep(.input) {
  padding-right: 24px !important;
}
</style>